document.addEventListener("DOMContentLoaded", () => {
  const features = document.querySelectorAll(".comparison-section__feature");
  const cards = document.querySelectorAll(".comparison__product-card");

  const syncHeights = () => {
    const isMobile = window.innerWidth <= 767;
    const firstRowHeight = isMobile ? "38px" : "46.67px";
    features.forEach((feature, i) => {
      if (i === 0) {
        feature.style.minHeight = firstRowHeight;
        cards.forEach((card) => {
          if (card.classList.contains("empty")) return;
          const inner = card.querySelector(".comparison__product-card--inner");
          if (!inner) return;
          const row = inner.children[i];
          if (
            row &&
            !row.classList.contains("comparison__product-card__remove")
          ) {
            row.style.minHeight = firstRowHeight;
          }
        });
        return;
      }

      let maxH = 0;
      cards.forEach((card) => {
        if (card.classList.contains("empty")) return;
        const inner = card.querySelector(".comparison__product-card--inner");
        if (!inner) return;
        const row = inner.children[i];
        if (
          row &&
          !row.classList.contains("comparison__product-card__remove")
        ) {
          maxH = Math.max(maxH, row.offsetHeight);
        }
      });

      if (maxH > 0) {
        feature.style.minHeight = i === 1 ? `${maxH + 5}px` : `${maxH}px`;
        if (isMobile) {
          feature.style.minHeight = i === 1 ? `${maxH + 3}px` : `${maxH}px`;
        }
        cards.forEach((card) => {
          if (card.classList.contains("empty")) return;
          const inner = card.querySelector(".comparison__product-card--inner");
          if (!inner) return;
          const row = inner.children[i];
          if (
            row &&
            !row.classList.contains("comparison__product-card__remove")
          ) {
            row.style.minHeight = `${maxH}px`;
          }
        });
      }
    });
  };

  const debounce = (fn, delay = 100) => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  };

  const debouncedSync = debounce(syncHeights, 120);
  syncHeights();
  window.addEventListener("load", syncHeights);
  window.addEventListener("resize", debouncedSync);
  setTimeout(syncHeights, 300);

  ////////////////////////// product fetch data dynamically ////////////////////////////////////

  const page = document.querySelector("[data-comparison-page]");
  if (!page) return;

  const modal = page.querySelector("[data-modal]");
  const searchInput = page.querySelector(".comparison-search");
  const resultsBox = page.querySelector(".search-results");
  const collectionCheckboxes = [
    ...page.querySelectorAll(".collection-checkbox"),
  ];

  let selectedCollections =
    JSON.parse(localStorage.getItem("comparisonSelectedCollections")) || [];

  let collectionProductsCache = [];

  // ✅ Global metafields cache — avoids fetching the same product twice
  const metafieldsCache = {};

  collectionCheckboxes.forEach((cb) => {
    cb.checked = selectedCollections.includes(cb.value);

    cb.addEventListener("change", async () => {
      selectedCollections = collectionCheckboxes
        .filter((c) => c.checked)
        .map((c) => c.value);

      localStorage.setItem(
        "comparisonSelectedCollections",
        JSON.stringify(selectedCollections),
      );

      resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
      collectionProductsCache = [];

      if (!selectedCollections.length) return;
      await fetchMultipleCollections(selectedCollections);
      renderCollectionResults(collectionProductsCache);
    });
  });

  // function autoSelectFirstCollectionIfNone() {
  //   const anySelected = collectionCheckboxes.some((cb) => cb.checked);
  //   if (anySelected) return;
  //   if (!collectionCheckboxes.length) return;

  //   const firstCheckbox = collectionCheckboxes[0];
  //   firstCheckbox.checked = true;
  //   selectedCollections = [firstCheckbox.value];

  //   localStorage.setItem(
  //     "comparisonSelectedCollections",
  //     JSON.stringify(selectedCollections),
  //   );

  //   fetchMultipleCollections(selectedCollections).then(() => {
  //     renderCollectionResults(collectionProductsCache);
  //     toggleCollectionFilters();
  //   });
  // }

  async function fetchMultipleCollections(handles) {
    const map = new Map();

    for (const handle of handles) {
      const res = await fetch(`/collections/${handle}/products.json?limit=250`);
      const data = await res.json();

      let products = data.products || [];

      if (handle === "rehab") {
        const allowedRehabProducts = ["ice-sleeve", "recovery-ice-wrap"];
        products = products.filter((p) =>
          allowedRehabProducts.includes(p.handle),
        );
      }

      products.forEach((p) => {
        if (!map.has(p.handle)) map.set(p.handle, p);
      });
    }

    collectionProductsCache = [...map.values()];
  }

  async function autoLoadSelectedCollections() {
    if (!selectedCollections.length) return;
    try {
      resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
      collectionProductsCache = [];
      await fetchMultipleCollections(selectedCollections);
      renderCollectionResults(collectionProductsCache);
    } catch (err) {
      console.error("Auto load collections failed", err);
    }
  }


  async function initCollections() {
    const anyProductAdded = Object.keys(stored).length > 0;

    // Only auto-select "rehab" when no products are in slots
    if (!anyProductAdded) {
      const rehabCheckbox = collectionCheckboxes.find((cb) => cb.value === "rehab");
      if (rehabCheckbox) {
        collectionCheckboxes.forEach((cb) => (cb.checked = false));
        rehabCheckbox.checked = true;
        selectedCollections = ["rehab"];
        localStorage.setItem("comparisonSelectedCollections", JSON.stringify(selectedCollections));
      }
    }
    // If products exist, restore previously selected collections from localStorage (already loaded above)

    if (!selectedCollections.length && collectionCheckboxes.length) {
      const firstCheckbox = collectionCheckboxes[0];
      firstCheckbox.checked = true;
      selectedCollections = [firstCheckbox.value];
      localStorage.setItem("comparisonSelectedCollections", JSON.stringify(selectedCollections));
    }

    if (!selectedCollections.length) return;

    try {
      resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
      collectionProductsCache = [];
      await fetchMultipleCollections(selectedCollections);
      renderCollectionResults(collectionProductsCache);
      toggleCollectionFilters();
    } catch (err) {
      console.error("Init collections failed", err);
    }
  }

// initCollections();

  const STORAGE_KEY = "comparisonProducts";
  let stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  let activeSlot = null;

  const slots = [...page.querySelectorAll(".comparison-slot")];

  initCollections();

  /* ---------------- UTIL ---------------- */

  function normalizeCollection(handle) {
    return handle.toLowerCase().trim().replace(/[\s_]/g, "-");
  }

  const saveStorage = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  };

  const getSelectedHandles = () => {
    return Object.values(stored).map((p) => p.handle);
  };

  const getFirstProductType = () => {
    const firstNonRehab = Object.values(stored).find(
      (item) =>
        item &&
        item.product_type &&
        item.product_type.toLowerCase() !== "rehab",
    );
    return firstNonRehab ? firstNonRehab.product_type : null;
  };

  const clearSlot = async (slot) => {
    delete stored[slot];
    saveStorage();
    await compactSlots();
  };

  function toggleCollectionFilters() {
    const filtersWrap = page.querySelector(".comparison-filters");
    if (!filtersWrap) return;

    const title = filtersWrap.querySelector(".filter-title");
    const items = [...filtersWrap.querySelectorAll(".filter-item")];
    if (!items.length || !title) return;

    items.forEach((item) => item.classList.remove("is-primary-selected"));

    const radios = filtersWrap.querySelectorAll(
      'input[type="radio"], input[type="checkbox"]',
    );
    radios.forEach((r) => (r.disabled = false));

    if (!selectedCollections.length) {
      items.forEach((item) => title.after(item));
      return;
    }

    const firstSelected = normalizeCollection(selectedCollections[0]);
    let selectedItem = null;
    let rehabItem = null;

    items.forEach((item) => {
      const input = item.querySelector("input");
      if (!input) return;
      if (normalizeCollection(input.value) === firstSelected)
        selectedItem = item;
      if (input.value === "rehab") rehabItem = item;
    });

    if (selectedItem) {
      title.after(selectedItem);
      selectedItem.classList.add("is-primary-selected");
    }

    if (rehabItem && rehabItem !== selectedItem) {
      selectedItem.after(rehabItem);
      rehabItem.classList.add("is-primary-selected");
    }
  }

  async function compactSlots() {
    const entries = Object.entries(stored).sort(
      ([a], [b]) => Number(a) - Number(b),
    );

    showSlotLoader(entries.length);
    await new Promise(requestAnimationFrame);

    stored = {};
    let newSlot = 1;

    for (const [, data] of entries) {
      const res = await fetch(`/products/${data.handle}.js`);
      const product = await res.json();

      stored[newSlot] = {
        handle: data.handle,
        variantId: data.variantId,
        product_type: data.product_type,
      };

      await renderProduct(newSlot, product, data.variantId, true);
      newSlot++;
    }

    saveStorage();

    // if (Object.keys(stored).length === 0) {
    //   localStorage.removeItem("comparisonSelectedCollections");
    //   selectedCollections = [];
    // }

    if (Object.keys(stored).length === 0) {
      // ✅ Force rehab selection again
      const rehabCheckbox = collectionCheckboxes.find(
        (cb) => cb.value === "rehab"
      );

      if (rehabCheckbox) {
        collectionCheckboxes.forEach((cb) => (cb.checked = false));

        rehabCheckbox.checked = true;
        selectedCollections = ["rehab"];

        localStorage.setItem(
          "comparisonSelectedCollections",
          JSON.stringify(selectedCollections)
        );
      } else {
        // fallback
        localStorage.removeItem("comparisonSelectedCollections");
        selectedCollections = [];
      }

      // ✅ Reload products for rehab
      resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
      collectionProductsCache = [];

      await fetchMultipleCollections(selectedCollections);
      renderCollectionResults(collectionProductsCache);
    }

    toggleCollectionFilters();
    debouncedSync();
  }

  function showSlotLoader(count) {
    slots.forEach((slotEl, index) => {
      const slotNumber = index + 1;

      if (slotNumber <= count) {
        slotEl.classList.remove("empty");
        slotEl.innerHTML = `
          <div class="comparison__product-card--inner comparison-loading">
            <div class="loader-image shimmer"></div>
            <div class="loader-line shimmer"></div>
            <div class="loader-line shimmer"></div>
            <div class="loader-line shimmer"></div>
          </div>
        `;
      } else {
        slotEl.classList.add("empty");
        slotEl.innerHTML = `
          <div class="comparison__product-card--inner">
            <div class="comparison__product-card__remove add-product-btn">
              <p>Add Product</p>
            </div>
            <div class="comparison__product-card__add add-product-btn">
              <img src="https://cdn.shopify.com/s/files/1/0625/2694/7534/files/plus-large.svg?v=1769158378">
            </div>
          </div>
        `;
      }
    });
  }

  /* ---------------- RESTORE ON LOAD ---------------- */

  // ✅ Restore all slots in parallel, then do ONE group pass at the end
  (async () => {
  const entries = Object.entries(stored);
    if (!entries.length) return;

    // Pre-fetch all metafields into cache first
    await Promise.all(
      entries.map(([, data]) => fetchProductMetafields(data.handle))
    );

    // Now group once — this handles showSlotLoader + render internally
    await groupSlotsBySupportLevel();
    debouncedSync();
  })();

  toggleCollectionFilters();

  /* ---------------- EVENTS ---------------- */

  page.addEventListener("click", async (e) => {
    /* ADD PRODUCT */
    const addBtn = e.target.closest(".add-product-btn");
    if (addBtn) {
      activeSlot = addBtn.closest(".comparison-slot");
      modal.classList.add("active");
      searchInput.value = "";
      resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;

      if (collectionProductsCache.length) {
        renderCollectionResults(collectionProductsCache);
      }

      const filtersWrap = modal.querySelector(".comparison-filters");
      if (filtersWrap) {
        setTimeout(() => {
          filtersWrap.scrollTop = 0;
        }, 100);
      }
      return;
    }

    /* CLOSE MODAL */
    if (e.target.closest(".modal-close")) {
      modal.classList.remove("active");
      return;
    }

    /* REMOVE PRODUCT */
    const removeBtn = e.target.closest(".remove-product");
    if (removeBtn) {
      const slot = removeBtn.closest(".comparison-slot").dataset.slot;
      clearSlot(slot);
      const allSlots = document.querySelectorAll(".comparison-slot");
      const allEmpty = [...allSlots].every(
        (slot) => !slot.querySelector(".product-card"),
      );
      if (allEmpty) {
        document
          .querySelectorAll(".filter-item.is-primary-selected")
          .forEach((item) => item.classList.remove("is-primary-selected"));
      }
    }

    /* ADD TO CART */
    const cartBtn = e.target.closest(".add-to-cart");
    if (cartBtn) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: cartBtn.dataset.variant, quantity: 1 }),
      });

      if (res.ok) {
        alert("Added to cart");
        window.location.reload();
      } else {
        const error = await res.json();
        alert(error?.description || "Unable to add to cart");
      }
    }
  });

  /* ---------------- SEARCH ---------------- */

  async function renderCollectionResults(products) {
    const selectedHandles = getSelectedHandles();
    const firstType = getFirstProductType();

    let filtered = products.filter((p) => {
      if (selectedHandles.includes(p.handle)) return false;
      if (firstType && p.product_type !== firstType) return false;
      return true;
    });

    // ✅ Use cache to avoid re-fetching metafields
    const productsWithMeta = await Promise.all(
      filtered.map(async (p) => {
        const metafields = await fetchProductMetafields(p.handle);
        return { ...p, metafields };
      }),
    );

    resultsBox.innerHTML = productsWithMeta.length
      ? productsWithMeta
          .map((p) => {
            const rawSupport = p.metafields?.support_level || "";
            const firstLetter = rawSupport
              ? rawSupport.charAt(0).toUpperCase()
              : "";

            const supportLevel = rawSupport
              ? `
              <div class="support-level">
                <span class="label">SUPPORT LEVEL:</span>
                <span class="support-circle">${firstLetter}</span>
                <span class="support-text">${rawSupport}</span>
              </div>
            `
              : "";

            const customImage = p.metafields?.custom_image || p.images[0]?.src;

            return `
        <div class="search-item" data-handle="${p.handle}">
          <img src="${customImage}" alt="${p.title}">
          <div class="search-info">
            <span>${p.title}</span>
            <small class="result-product-type product-type-${p.product_type
              .toLowerCase()
              .replace(/\s+/g, "-")}">
              ${supportLevel}
            </small>
          </div>
          <button class="add-btn">Add 
            <span>
              <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                <path d="M4 12H20M12 4V20" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </button>
        </div>
      `;
          })
          .join("")
      : `<div class="search-empty">No compatible products found</div>`;
  }

  let searchAbortController = null;

  searchInput.addEventListener("input", async () => {
    const q = searchInput.value.trim().toLowerCase();

    if (searchAbortController) {
      searchAbortController.abort();
      searchAbortController = null;
    }

    if (!q) {
      if (!collectionProductsCache.length) {
        resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
        return;
      }
      renderCollectionResults(collectionProductsCache);
      return;
    }

    searchAbortController = new AbortController();
    const signal = searchAbortController.signal;

    try {
      resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;

      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=20`,
        { signal },
      );
      const data = await res.json();
      const allProducts = data?.resources?.results?.products || [];

      if (signal.aborted) return;

      const normalizedProducts = allProducts.map((p) => ({
        handle: p.handle,
        title: p.title,
        images: [{ src: p.featured_image?.url || p.image }],
        product_type: p.product_type || "",
        variants: p.variants || [],
      }));

      renderCollectionResults(normalizedProducts);
    } catch (err) {
      if (err.name === "AbortError") return;
      console.error("Global search failed", err);
      const filtered = collectionProductsCache.filter((p) =>
        p.title.toLowerCase().includes(q),
      );
      renderCollectionResults(filtered);
    }
  });

  /* ---------------- SELECT PRODUCT ---------------- */

  resultsBox.addEventListener("click", async (e) => {
    const btn = e.target.closest(".add-btn");
    if (!btn || !activeSlot) return;

    const item = btn.closest(".search-item");
    const targetSlot = activeSlot.dataset.slot;

    modal.classList.remove("active");

    const res = await fetch(`/products/${item.dataset.handle}.js`);
    const product = await res.json();

    // ✅ Pre-fetch metafields into cache before renderProduct runs
    await fetchProductMetafields(product.handle);

    // ✅ Save to stored BEFORE grouping so group has the new product
    stored[targetSlot] = {
      handle: product.handle,
      variantId: product.variants[0].id,
      product_type: product.product_type,
      collection: selectedCollections[0] || null,
    };
    saveStorage();

    // ✅ Group slots by support level first (uses cache), then render all
    await groupSlotsBySupportLevel();

    debouncedSync();
    syncHeights();
  });

  /* ---------------- RENDER ---------------- */

  // ✅ Cached metafield fetcher — only fetches once per product handle
  async function fetchProductMetafields(handle) {
    if (metafieldsCache[handle]) return metafieldsCache[handle];
    try {
      const res = await fetch(`/products/${handle}?view=metafields`);
      if (!res.ok) return {};
      const data = await res.json();
      metafieldsCache[handle] = data;
      return data;
    } catch (e) {
      console.error("Metafields fetch failed", e);
      return {};
    }
  }

  function formatPriceWithGST(variant) {
    const base = variant.price / 100;

    if (variant.taxable) {
      const incGST = base * 1.1;
      return `
        <p>
          <strong>$${incGST.toFixed(2)}</strong>
          <small> Inc. GST</small>
        </p>
      `;
    }

    return `
      <p>
        <strong>$${base.toFixed(2)}</strong>
        <small> GST Free</small>
      </p>
    `;
  }

  /* ---------------- GROUP SLOTS BY SUPPORT LEVEL ---------------- */

  // ✅ Uses metafields cache — no extra network requests
  // ✅ Sorts stored in-memory, then re-renders all filled slots once
  async function groupSlotsBySupportLevel() {
    const entries = Object.entries(stored);
    if (entries.length < 2) {
      // Only 1 product — still render it directly
      if (entries.length === 1) {
        const [slot, data] = entries[0];
        const res = await fetch(`/products/${data.handle}.js`);
        const product = await res.json();
        await renderProduct(slot, product, data.variantId, true);
      }
      return;
    }

    // Fetch support levels using cache (no new network requests if already cached)
    const slotData = await Promise.all(
      entries.map(async ([slot, data]) => {
        const meta = await fetchProductMetafields(data.handle);
        return {
          slot: Number(slot),
          handle: data.handle,
          variantId: data.variantId,
          product_type: data.product_type,
          collection: data.collection || null,
          supportLevel: (meta.support_level || "").toLowerCase().trim(),
        };
      }),
    );

    // Sort: group same support levels together, keeping original slot order as tiebreaker
    // Sort: group same support levels together, push empty/N/A to the last available slot
    // Sort by clinical support level order, empty/N/A always last
      const SUPPORT_ORDER = [
        "mild",
        "moderate",
        "firm/moderate",
        "stabilising",
        "advanced",
        "advanced stabilising",
        "extreme",
      ];

      const isEmptyLevel = (level) => !level || level === "n/a" || level === "na";

      const getSupportRank = (level) => {
        if (isEmptyLevel(level)) return Infinity;
        const idx = SUPPORT_ORDER.indexOf(level);
        return idx === -1 ? SUPPORT_ORDER.length : idx; // unknown values sort before empty but after known
      };

      slotData.sort((a, b) => {
        const rankA = getSupportRank(a.supportLevel);
        const rankB = getSupportRank(b.supportLevel);
        if (rankA !== rankB) return rankA - rankB;
        return a.slot - b.slot; // preserve original order as tiebreaker for same level
      });

    // Re-assign stored with sorted order
    stored = {};
    slotData.forEach((item, i) => {
      stored[i + 1] = {
        handle: item.handle,
        variantId: item.variantId,
        product_type: item.product_type,
        collection: item.collection,
      };
    });
    saveStorage();

    // Show loaders for all filled slots
    showSlotLoader(slotData.length);
    await new Promise(requestAnimationFrame);

    // ✅ Fetch all products in parallel, then render sequentially
    const productFetches = await Promise.all(
      slotData.map((item) =>
        fetch(`/products/${item.handle}.js`).then((r) => r.json()),
      ),
    );

    for (let i = 0; i < slotData.length; i++) {
      await renderProduct(
        i + 1,
        productFetches[i],
        slotData[i].variantId,
        true,
      );
    }

    toggleCollectionFilters();
    debouncedSync();
  }

  // ✅ skipGroup=true skips grouping (used internally by groupSlotsBySupportLevel)

  function initClampButtons(scope = document) {
    scope.querySelectorAll(".comparison-clamp").forEach((box) => {
      const key = box.dataset.clamp;
      const btn = scope.querySelector(`[data-clamp-btn="${key}"]`);
      if (!btn) return;

      box.classList.add("collapsed");
      if (box.scrollHeight > box.clientHeight + 4) {
        btn.style.display = "inline-block";
      }

      btn.addEventListener("click", () => {
        const isCollapsed = box.classList.contains("collapsed");
        box.classList.toggle("collapsed", !isCollapsed);
        box.classList.toggle("expanded", isCollapsed);
        btn.textContent = isCollapsed ? "Read less" : "Read more";
      });
    });
  }

async function renderProduct(slot, product, variantId, skipGroup = false) {
  /* ---------- METAFIELDS (uses cache) ---------- */
  const meta = await fetchProductMetafields(product.handle);

  const benefits = meta.benefits?.length
    ? `<ul>${meta.benefits.map((b) => `<li>${b}</li>`).join("")}</ul>`
    : `<p>-</p>`;

  const bestFor = meta.best_for
    ? `<p>${meta.best_for}</p>`
    : `<p>-</p>`;

  const features = meta.features?.length
    ? `<ul>${meta.features.map((f) => `<li>${f}</li>`).join("")}</ul>`
    : `<p>-</p>`;

  // const injuries = meta.injuries ? `<p>${meta.injuries}</p>` : `<p>-</p>`;

  function splitInjuries(raw) {
    if (!raw || !raw.trim()) return null;

    let parts = [];

    // Handle newline-delimited format (each line may start with "- " or "* ")
    if (raw.includes('\n')) {
      parts = raw
        .split('\n')
        .map(p => p.replace(/^[\-\*]\s*/, '').trim()) // strip leading "- " or "* "
        .filter(Boolean);
      return parts.length ? parts : null;
    }

    // Handle " - " delimited format (e.g. "* - Item one - Item two")
    if (raw.includes(' - ')) {
      parts = raw
        .split(' - ')
        .map(p => p.replace(/^[\-\*]\s*/, '').trim())
        .filter(Boolean);
      return parts.length ? parts : null;
    }

    // Original comma-split logic (respects parentheses)
    let depth = 0, current = '';
    for (const ch of raw) {
      if (ch === '(') { depth++; current += ch; }
      else if (ch === ')') { depth--; current += ch; }
      else if (ch === ',' && depth === 0) {
        const trimmed = current.trim();
        if (trimmed) parts.push(trimmed);
        current = '';
      } else { current += ch; }
    }
    if (current.trim()) parts.push(current.trim());
    return parts;
  }

  const injuryParts = splitInjuries(meta.injuries || '');
  const injuries = injuryParts && injuryParts.length > 0
    ? `<ul>${injuryParts.map(p => `<li>${p}</li>`).join('')}</ul>`
    : `<p>-</p>`;

  const supportLevel = meta.support_level
    ? `<p><strong>${meta.support_level}</strong></p>`
    : `<p>-</p>`;

  /* ---------- SIZE & COLOR TEXT ---------- */
  let sizeIndex = -1;
  let colorIndex = -1;

  product.options.forEach((opt, i) => {
    const name =
      typeof opt === "string" ? opt.toLowerCase() : opt?.name?.toLowerCase();
    if (name === "size") sizeIndex = i;
    if (name === "color") colorIndex = i;
  });

  const sizeText =
    sizeIndex !== -1
      ? [
          ...new Set(
            product.variants
              .filter((v) => v.available)
              .map((v) => v.options[sizeIndex])
          ),
        ].join(", ")
      : "-";

  const colorText =
    colorIndex !== -1
      ? [
          ...new Set(
            product.variants
              .filter((v) => v.available)
              .map((v) => v.options[colorIndex])
          ),
        ].join(", ")
      : "-";

  /* ---------- VARIANT DROPDOWNS ---------- */
  function getAvailableOptions(index) {
    if (index === -1) return [];
    return [
      ...new Set(
        product.variants
          .filter((v) => v.available)
          .map((v) => v.options[index])
      ),
    ];
  }

  const dropdownHTML = `
    <div class="comparison-variants">
      ${
        sizeIndex !== -1
          ? `
        <div class="comparison-variant">
          <label>Size</label>
          <select class="variant-select" data-index="${sizeIndex}">
            ${getAvailableOptions(sizeIndex)
              .map((v) => `<option value="${v}">${v}</option>`)
              .join("")}
          </select>
        </div>`
          : ""
      }
      ${
        colorIndex !== -1
          ? `
        <div class="comparison-variant">
          <label>Color</label>
          <select class="variant-select" data-index="${colorIndex}">
            ${getAvailableOptions(colorIndex)
              .map((v) => `<option value="${v}">${v}</option>`)
              .join("")}
          </select>
        </div>`
          : ""
      }
    </div>
  `;

  /* ---------- SAVE STATE ---------- */
  stored[slot] = {
    handle: product.handle,
    variantId,
    product_type: product.product_type,
    collection: selectedCollections[0] || null,
  };
  saveStorage();
  toggleCollectionFilters();

  /* ---------- RENDER HTML ---------- */
  const card = page.querySelector(`[data-slot="${slot}"]`);
  card.classList.remove("empty");

  card.innerHTML = `
    <div class="comparison__product-card--inner">
      <div class="comparison__product-card__remove remove-product" data-row="spacer">
        <p>Remove Product</p>
      </div>
      <div class="comparison__product-card__image" data-row="image">
        <img src="${product.images[0]}" alt="${product.title}">
      </div>
      <div class="comparison__product-card__title" data-row="title">
        <h3>${product.title}</h3>
      </div>
      <!-- SUPPORT LEVEL -->
      <div class="comparison__product-card__value" data-row="support">
        ${supportLevel}
      </div>
      <!-- PRICE -->
      <div class="comparison__product-card__value price-value" data-row="price">
        ${formatPriceWithGST(product.variants.find((v) => v.id === variantId))}
      </div>
      <!-- SIZES TEXT -->
      <div class="comparison__product-card__value" data-row="size">
        <p>${sizeText || "-"}</p>
      </div>
      <!-- COLOR TEXT -->
      <div class="comparison__product-card__value" data-row="color">
        <p>${colorText || "-"}</p>
      </div>
      <!-- BENEFITS -->
      <div class="comparison__product-card__value" data-row="benefits">
        <div class="comparison-clamp collapsed" data-clamp="benefits-${slot}">
          ${benefits}
        </div>
        <button class="comparison-see-more" data-clamp-btn="benefits-${slot}">Read more</button>
      </div>
      <!-- BEST FOR -->
      <div class="comparison__product-card__value" data-row="best_for">
        <div class="comparison-clamp collapsed" data-clamp="best_for-${slot}">
          ${bestFor}
        </div>
        <button class="comparison-see-more" data-clamp-btn="best_for-${slot}">Read more</button>
      </div>
      <!-- FEATURES -->
      <div class="comparison__product-card__value" data-row="features">
        ${features}
      </div>
      <!-- RELATED INJURIES -->
      <div class="comparison__product-card__value" data-row="injuries">
        ${injuries}
      </div>
    </div>
    <!-- VARIANT DROPDOWNS -->
    <div class="comparison__product-card__value">
      ${dropdownHTML}
    </div>
    <div class="comparison__product-card__cta">
      <button class="btn btn--primary add-to-cart" data-variant="${variantId}">
        Add to Cart
      </button>
      <a href="/products/${product.handle}" class="btn btn--secondary">
        View Product
      </a>
    </div>
  `;

    /* ---------- VARIANT MATCHING ---------- */
    const selects = card.querySelectorAll(".variant-select");
    const priceBox = card.querySelector(".price-value");
    const addBtn = card.querySelector(".add-to-cart");

    function findVariant() {
      const selected = {};
      selects.forEach((s) => (selected[s.dataset.index] = s.value));
      return product.variants.find(
        (v) =>
          v.available &&
          Object.keys(selected).every((i) => v.options[i] === selected[i]),
      );
    }

    function updateVariant() {
      const matched = findVariant();
      if (!matched) return;
      addBtn.dataset.variant = matched.id;
      priceBox.innerHTML = formatPriceWithGST(matched);
      stored[slot].variantId = matched.id;
      saveStorage();
    }

    selects.forEach((s) => s.addEventListener("change", updateVariant));
    updateVariant();
    setTimeout(() => initClampButtons(card), 50);
}

  /* ---------------- AUTO ADD PRODUCT FROM URL ---------------- */

  function getQueryParams() {
    const params = {};
    window.location.search
      .substring(1)
      .split("&")
      .forEach((pair) => {
        const [key, value] = pair.split("=");
        if (key) params[key] = decodeURIComponent(value || "");
      });
    return params;
  }

  function clearURLParams() {
    const url = new URL(window.location);
    url.search = "";
    window.history.replaceState({}, document.title, url.toString());
  }

  async function autoSelectCollectionsFromURL(urlCollections) {
    if (!urlCollections.length) return;

    const normalized = urlCollections.map((c) => normalizeCollection(c));
    selectedCollections = normalized;

    collectionCheckboxes.forEach((cb) => {
      cb.checked = normalized.includes(normalizeCollection(cb.value));
    });

    localStorage.setItem(
      "comparisonSelectedCollections",
      JSON.stringify(selectedCollections),
    );

    resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
    collectionProductsCache = [];

    await fetchMultipleCollections(selectedCollections);
    renderCollectionResults(collectionProductsCache);
    toggleCollectionFilters();
  }

  async function addProductFromURL() {
    const params = getQueryParams();
    const handle = params.handle;
    const urlCollections = params.collections
      ? params.collections.split(",").map((c) => c.trim())
      : [];

    if (!handle) return;

    const storedHandles = getSelectedHandles();
    if (storedHandles.includes(handle)) {
      alert("Product already added to comparison");
      clearURLParams();
      return;
    }

    const emptySlot = slots.find((slot) => !stored[slot.dataset.slot]);
    if (!emptySlot) {
      alert("All slots are full");
      clearURLParams();
      return;
    }

    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      // Determine which collection to activate:
      // 1. Prefer explicit URL param  2. Derive from product_type  3. Keep current
      if (urlCollections.length) {
        await autoSelectCollectionsFromURL(urlCollections);
      } else {
        // Derive collection from product_type (normalise to a handle-style string)
        const derivedCollection = product.product_type
          ? normalizeCollection(product.product_type)
          : null;

        if (derivedCollection) {
          const matchingCheckbox = collectionCheckboxes.find(
            (cb) => normalizeCollection(cb.value) === derivedCollection
          );

          if (matchingCheckbox) {
            collectionCheckboxes.forEach((cb) => (cb.checked = false));
            matchingCheckbox.checked = true;
            selectedCollections = [matchingCheckbox.value];
            localStorage.setItem(
              "comparisonSelectedCollections",
              JSON.stringify(selectedCollections)
            );

            resultsBox.innerHTML = `<div class="search-loading">Loading...</div>`;
            collectionProductsCache = [];
            await fetchMultipleCollections(selectedCollections);
            renderCollectionResults(collectionProductsCache);
            toggleCollectionFilters();
          }
        }
      }

      await fetchProductMetafields(product.handle);

      stored[emptySlot.dataset.slot] = {
        handle: product.handle,
        variantId: product.variants[0].id,
        product_type: product.product_type,
        collection: selectedCollections[0] || null,
      };
      saveStorage();

      await groupSlotsBySupportLevel();
      debouncedSync();
      clearURLParams();
    } catch (err) {
      console.error("Failed to fetch product from URL", err);
      clearURLParams();
    }
  }

  addProductFromURL();
});


let initialLeftHeights = {}; // ✅ one per row now, not a single global value
const ANIMATION_TIME = 300;

window.addEventListener("load", () => {
  document
    .querySelectorAll(".comparison-section__feature[data-row]")
    .forEach((feature) => {
      const row = feature.dataset.row;
      initialLeftHeights[row] =
        parseFloat(window.getComputedStyle(feature).minHeight) || 166;
    });
});

// const initialCellHeights = new WeakMap();

// window.addEventListener("load", () => {
//   document.querySelectorAll("[data-row]").forEach((el) => {
//     initialCellHeights.set(
//       el,
//       parseFloat(window.getComputedStyle(el).minHeight) || el.offsetHeight
//     );
//   });
// });

document.addEventListener("click", function (e) {
  if (!e.target.classList.contains("comparison-see-more")) return;

  const btn = e.target;
  const wrapper = btn.closest(".comparison-section__wrapper");

  const clamp = wrapper.querySelector(
    `[data-clamp="${btn.dataset.clampBtn}"]`
  );
  if (!clamp) return;

  // ✅ Derive the row name from the clamp key, e.g. "best_for-3" -> "best_for"
  const rowName = btn.dataset.clampBtn.replace(/-\d+$/, "");

  const left = wrapper.querySelector(
    `.comparison-section__feature[data-row="${rowName}"]`
  );

  // ✅ Only target clamps/buttons/cells that belong to THIS row
  const allClamps = wrapper.querySelectorAll(
    `[data-clamp^="${rowName}-"]`
  );
  const allButtons = wrapper.querySelectorAll(
    `[data-clamp-btn^="${rowName}-"]`
  );
  const rightCells = wrapper.querySelectorAll(
    `.comparison__product-card [data-row="${rowName}"]`
  );

  if (!left) return;

  setTimeout(() => {
    const isExpanded = clamp.classList.contains("expanded");

    if (isExpanded) {
      // ✅ EXPAND ALL (only this row)
      allClamps.forEach((c) => {
        c.classList.add("expanded");
        c.classList.remove("collapsed");
      });

      allButtons.forEach((b) => (b.textContent = "Read less"));

      left.style.minHeight = "auto";
      rightCells.forEach((el) => {
        el.style.minHeight = "auto";
      });

      requestAnimationFrame(() => {
        let maxHeight = 0;
        maxHeight = Math.max(maxHeight, left.scrollHeight);
        rightCells.forEach((el) => {
          maxHeight = Math.max(maxHeight, el.scrollHeight);
        });

        left.style.minHeight = maxHeight + "px";
        rightCells.forEach((el) => {
          el.style.minHeight = maxHeight + "px";
        });
      });

    } else {
      // ✅ COLLAPSE ALL (only this row)
      allClamps.forEach((c) => {
        c.classList.remove("expanded");
        c.classList.add("collapsed");
      });

      allButtons.forEach((b) => (b.textContent = "Read more"));

      left.style.minHeight = (initialLeftHeights[rowName] || 166) + "px";

    rightCells.forEach((el) => {
      el.style.minHeight = "174px";
    });

    left.style.minHeight = "174px";
    }
  }, ANIMATION_TIME);
});
